module.exports = __webpack_public_path__ + "static/img/zhifuweixin.fe5b02c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhifuweixin.jpg
// module id = 0wrI
// module chunks = 4